export const LAB_LINKS = {
  IGI: 'https://igi.org/verify.php?r=***',
  GSI: 'http://wg.gemscience.net/vr/veri.aspx',
  GIA: 'https://www.gia.edu/report-check?reportno=***',
  HRD: 'https://my.hrdantwerp.com/?id=34&record_number=***',
};

export const SORTABLE_COLUMNS = {
  carat: 'Carat',
  clrNm: 'Clarity',
  colNm: 'Color',
  color: 'Color',
  crt: 'Carat',
  shape: 'Shape',
  shpNm: 'Shape',
  stoneId: 'Packet No',
};

// prettier-ignore
export const ALT_COLUMNS = ['amt', 'back', 'ctPr', 'dna', 'locNm', 'rap', 'selection', 'srNo', 'vStnId'];
// prettier-ignore
export const BOLD_COLUMNS = ['stoneId', 'vStnId', 'amt', 'prvCtPr', 'prvBack', 'colNm', 'shpNm', 'crt', 'clrNm', 'shdNm', 'rap', 'back', 'ctPr', 'cutNm', 'polNm', 'symNm', 'brlncyNm', 'bidDiscount', 'bidPricePerCarat', 'bidAmount', 'fluNm', 'blockPricePerCarat', 'blockAmount', 'blockDiscount', 'oldCtPr', 'oldAmt', 'oldBack', 'baseBack', 'baseAmt', 'baseCtpr', 'cstPerBlw', 'cstPrCrt', 'totCst'];
// prettier-ignore
export const TOTAL_COLUMNS = ['amt', 'back', 'crt', 'ctPr', 'rap'];
// prettier-ignore
export const FILTER_COLUMNS = ['crt','blkSdNm', 'blkTblNm', 'brlncyNm', 'clrNm', 'colNm', 'cultNm', 'cutNm', 'eClnNm', 'fluNm', 'girdleStr', 'hANm', 'lbNm', 'locNm', 'country', 'countryNm', 'opCrwnNm', 'opPavNm', 'opTblNm', 'polNm', 'shdNm', 'shpNm', 'symNm', 'wSdNm', 'wTblNm'];
// prettier-ignore
export const FLOAT_COLUMNS = ['amt', 'back', 'bidAmount', 'bidDiscount', 'bidPricePerCarat', 'cAng', 'cHgt', 'crt', 'ctPr', 'depPer', 'fnDis', 'grdlPer', 'height', 'length', 'lwrHal', 'newDiscount', 'pAng', 'pHgt', 'prvBack', 'prvCtPr', 'rapAvg', 'ratio', 'strLn', 'tblPer', 'width', 'oldAmt', 'oldCtPr', 'baseBack', 'baseAmt', 'baseCtpr', 'rap', 'blockPricePerCarat', 'blockAmount', 'blockDiscount', 'cstPerBlw', 'cstPrCrt', 'totCst'];
// prettier-ignore
export const NOCHECK_COLUMNS = ['Action', 'approve', 'bidPricePerCarat', 'confirm', 'Details', 'dna', 'expBack', 'FutureDisc', 'hours', 'lbNm', 'note', 'quote', 'reject', 'reject', 'stockCount', 'video', 'invoice'];
// prettier-ignore
export const ROUND_COLUMNS = ['amt', 'rap'];
// prettier-ignore
export const CURRENCY_COLUMNS =  ['amt', 'rap', 'ctPr', 'blockAmount', 'blockPricePerCarat', 'oldCtPr', 'oldAmt', 'baseAmt', 'baseCtpr', 'cstPrCrt', 'totCst'];

export const DISCOUNT_COLUMNS = ['back', 'blockDiscount', 'oldBack', 'baseBack', 'cstPerBlw'];

export const PRICE_COLUMNS = ['amt', 'back', 'ctPr'];

export const BASE_PRICE_COLUMNS = ['baseBack', 'baseAmt', 'baseCtpr'];

export const COST_PRICE_COLUMNS = ['cstPerBlw', 'cstPrCrt', 'totCst'];

export const PAGE_LIMIT = 250;
